import {createFeatureSelector, createSelector} from '@ngrx/store';
import { exportTemplatesFeatureKey, ExportTemplatesState } from './export-templates.reducer';

const selectElementsState = createFeatureSelector<ExportTemplatesState>(exportTemplatesFeatureKey);

export const selectExportTemplatesForm = createSelector(
    selectElementsState,
    state => state
);
